// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRuroOutlinedSvg from "@fishx/icons-svg/es/asn/PRuroOutlined";
import FishxIcon from '../components/FishxIcon';

var PRuroOutlined = function PRuroOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRuroOutlinedSvg
  }));
};

PRuroOutlined.displayName = 'PRuroOutlined';
export default React.forwardRef(PRuroOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRuroOutlined.js
// module id = 3614
// module chunks = 0